export default __webpack_public_path__ + "static/media/nesto-online-app1.38ed8de3.png";